import { Link } from "react-router-dom";
import { ArrowLeft, ExternalLink, FileText, Clock, Wallet } from "lucide-react";
import PageShell from "@/components/PageShell";

export const PORTAL_URL = "https://payme.astutepayroll.com/payme/auth/login";

const ITEMS = [
    { icon: Clock, title: "Submit timesheets", text: "Enter your hours for the pay period." },
    { icon: FileText, title: "Download payslips", text: "Draft and final payslips, any time." },
    { icon: Wallet, title: "Update your details", text: "Tax, super and bank details in one place." },
];

export default function Portal() {
    return (
        <PageShell testId="portal-page">
            <main className="mx-auto max-w-7xl px-5 pb-24 pt-10 md:px-8 md:pt-14">
                <Link to="/" className="inline-flex items-center gap-2 rounded-lg border border-primary px-4 py-2 text-sm font-semibold text-primary transition-colors hover:bg-primary hover:text-white" data-testid="portal-return-btn">
                    <ArrowLeft size={15} /> Return to the PayMe Website
                </Link>

                <div className="mt-10 grid gap-12 lg:grid-cols-2 lg:items-center">
                    <div>
                        <p className="text-sm font-semibold uppercase tracking-wider text-muted-foreground">Contractor Portal</p>
                        <h1 className="mt-2 font-display text-4xl font-bold leading-tight text-primary sm:text-5xl" data-testid="page-title">PayMe Portal</h1>
                        <p className="mt-5 max-w-xl text-lg text-foreground/80">
                            The PayMe Portal is where you submit timesheets, download payslips and keep your payroll details up to date. It opens in a new tab so this website stays open for you to come back to.
                        </p>
                        <div className="mt-8 flex flex-wrap gap-3">
                            <a href={PORTAL_URL} target="_blank" rel="noopener noreferrer" data-testid="portal-open-btn" className="inline-flex items-center gap-2 rounded-lg bg-primary px-6 py-3 text-base font-semibold text-white transition-colors hover:bg-primary/90">
                                Open PayMe Portal <ExternalLink size={16} />
                            </a>
                            <Link to="/join" data-testid="portal-join-link" className="inline-flex items-center rounded-lg border border-primary px-6 py-3 text-base font-semibold text-primary transition-colors hover:bg-primary hover:text-white">
                                New to PayMe? Join here
                            </Link>
                        </div>
                        <p className="mt-6 text-sm text-muted-foreground">
                            Trouble logging in? Call <a href="tel:1800082006" className="font-semibold text-primary">1800 082 006</a> or email <a href="mailto:timesheets@payme.com.au" className="font-semibold text-primary">timesheets@payme.com.au</a>.
                        </p>
                    </div>
                    <ul className="grid gap-4">
                        {ITEMS.map(({ icon: Icon, title, text }) => (
                            <li key={title} className="flex items-start gap-4 rounded-lg border border-border bg-white p-5">
                                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-surface-2 text-primary"><Icon size={20} /></span>
                                <div>
                                    <p className="font-display text-lg font-bold text-primary">{title}</p>
                                    <p className="mt-1 text-base text-foreground/80">{text}</p>
                                </div>
                            </li>
                        ))}
                    </ul>
                </div>
            </main>
        </PageShell>
    );
}
